// 供需与发布：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 移动线索
export const mobileClue = Object.freeze({
  "mobileClue.searchPlaceholder": "請在此輸入搜索關鍵詞",
  "mobileClue.noData": "暫無數據",
  "mobileClue.supplyPublished": "貨源發佈成功！",
  "mobileClue.demandPublished": "需求發佈成功！",
  "mobileClue.supplyReviewHint": "貨源資料審核通過後，即可分配談判人",
  "mobileClue.demandReviewHint": "需求資料審核通過後，即可分配談判人",
  "mobileClue.backHome": "返回首頁",
  "mobileClue.searchPartOrName": "搜索料號、名稱",
  "mobileClue.search": "搜索",
  "mobileClue.listEnd": "我們是有底線的",
  "mobileClue.supply": "貨源",
  "mobileClue.wantToBuy": "求購",
});

// 批量发布
export const batchPublish = Object.freeze({
  "pcBatch.title": "批量導入",
  "pcBatch.supply": "批量發佈供應",
  "pcBatch.demand": "批量發佈需求",
  "pcBatch.uploadTab": "檔案上傳",
  "pcBatch.drag": "將檔案拖到此處，或",
  "pcBatch.clickUpload": "點擊上傳",
  "pcBatch.limit": "支持 xls/xlsx，單次最多 200 條記錄",
  "pcBatch.remove": "移除",
  "pcBatch.import": "導入",
  "pcBatch.downloadTemplate": "下載模板",
  "pcBatch.templateHint":
    "提示：檔案將採用程序自動處理，請使用標準模板，以減少轉換錯誤。",
  "pcBatch.maximumBefore": "批量導入每次發佈上限",
  "pcBatch.maximumAfter": "條。",
  "pcBatch.result": "導入結果",
  "pcBatch.clear": "清除",
  "pcBatch.successCount": "成功：{count} 條；",
  "pcBatch.failureCount": "失敗：{count} 條",
  "pcBatch.excelOnly": "僅支持上傳 Excel 檔案（.xls/.xlsx）。",
  "pcBatch.chooseFile": "請先選擇 Excel 檔案。",
  "pcBatch.importSuccess": "導入成功",
  "pcBatch.importFailed": "導入失敗，請重試",
  "pcBatch.networkOrFileError": "導入失敗，請檢查網絡或檔案內容",
});

// 桌面线索
export const desktopClue = Object.freeze({
  "pcClue.searchPlaceholder": "搜索料號、名稱",
  "pcClue.productType": "產品類型：",
  "pcClue.productBrand": "產品品牌：",
  "pcClue.goodsLocationLabel": "貨所在地：",
  "pcClue.goodsCondition": "貨物情況：",
  "pcClue.all": "全部",
  "pcClue.expand": "展開",
  "pcClue.collapse": "收起",
  "pcClue.publish": "供求發佈",
  "pcClue.manage": "管理",
  "pcClue.supply": "供應",
  "pcClue.demand": "需求",
  "pcClue.buy": "求購",
  "pcClue.wide": "寬",
  "pcClue.narrow": "窄",
  "pcClue.card": "卡片",
  "pcClue.list": "列表",
  "pcClue.endOfList": "我們是有底線的",
  "pcClue.loadFailed": "獲取數據失敗，請重新載入",
  "pcClue.type": "類型",
  "pcClue.partNumber": "料號",
  "pcClue.brand": "品牌",
  "pcClue.category": "分類",
  "pcClue.location": "所在地",
  "pcClue.currency": "貨幣",
  "pcClue.usd": "美元",
  "pcClue.cny": "人民幣",
  "pcClue.price": "價格",
  "pcClue.quantity": "數量",
  "pcClue.batch": "批次",
  "pcClue.condition": "貨態",
  "pcClue.originalManufacturer": "原廠",
  "pcClue.deliveryTime": "交貨時間",
  "pcClue.days": "{count}天",
  "pcClue.undetermined": "未定",
  "pcClue.publishedAt": "發佈時間",
  "pcClue.publisher": "發佈人",
  "pcClue.brandNew": "全新",
  "pcClue.stock": "庫存",
  "pcClue.demandQuantity": "需求量",
  "pcClue.minimumOrder": "起訂",
  "pcClue.deposit": "保證金",
  "pcClue.region": "地區",
  "pcClue.bidDeadline": "截標",
  "pcClue.bidOpening": "開標",
  "pcClue.fiveSuppliers": "5家",
  "pcClue.selectedCount": "已選擇 {count} 項",
  "pcClue.delete": "刪除",
  "pcClue.review": "審核",
  "pcClue.monthDay": "{month}月{day}日",
  "pcClue.brand.skHynix": "海力士",
  "pcClue.brand.samsung": "三星",
  "pcClue.brand.micron": "美光",
  "pcClue.brand.infineon": "英飛凌",
  "pcClue.brand.nxp": "恩智浦",
  "pcClue.brand.st": "意法半導體",
  "pcClue.brand.ti": "德州儀器",
  "pcClue.brand.espressif": "樂鑫",
  "pcClue.brand.gigaDevice": "兆易創新",
  "pcClue.brand.winbond": "華邦",
  "pcClue.brand.nanya": "南亞",
  "pcClue.brand.broadcom": "博通",
  "pcClue.brand.qualcomm": "高通",
  "pcClue.brand.mediatek": "聯發科",
  "pcClue.hongKong": "香港",
  "pcClue.domestic": "國內",
  "pcClue.bondedArea": "保税區",
  "pcClue.other": "其他",
  "pcClue.originalCarton": "原箱",
  "pcClue.genuine": "原裝",
  "pcClue.originalPackage": "原包",
  "pcClue.originalLabel": "原標",
});

// 货源发布
export const sourcePublish = Object.freeze({
  "sourcePublish.ownerInfo": "貨主資料",
  "sourcePublish.iAmOwner": "我是貨主",
  "sourcePublish.contact": "聯絡人",
  "sourcePublish.enterContact": "請填寫聯絡人",
  "sourcePublish.required": "不能為空",
  "sourcePublish.ms": "女士",
  "sourcePublish.mr": "先生",
  "sourcePublish.contactMethod": "聯絡方式",
  "sourcePublish.enterMobile": "請填寫流動電話號碼",
  "sourcePublish.wechat": "微信",
  "sourcePublish.enterWechat": "請填寫微信號",
  "sourcePublish.hometown": "籍貫",
  "sourcePublish.enterHometown": "請填寫籍貫",
  "sourcePublish.personality": "性格",
  "sourcePublish.hobbies": "愛好",
  "sourcePublish.remarks": "備註",
  "sourcePublish.ownerRemarks": "請填寫貨主資料備註",
  "sourcePublish.productInfo": "產品資料",
  "sourcePublish.productLink": "商品id/鏈接",
  "sourcePublish.enterProductLink": "請填寫供需頻道id或鏈接",
  "sourcePublish.images": "圖片",
  "sourcePublish.imageHint": "拖拽排序，雙擊查看圖片",
  "sourcePublish.uploadProductImages": "上傳產品圖片",
  "sourcePublish.productName": "產品名稱",
  "sourcePublish.enterProductName": "請填寫產品名稱",
  "sourcePublish.brand": "品牌",
  "sourcePublish.enterBrand": "請填寫品牌名稱",
  "sourcePublish.selectBrand": "選擇品牌",
  "sourcePublish.partNumber": "規格料號",
  "sourcePublish.enterPartNumber": "請填寫規格料號",
  "sourcePublish.manufactureDate": "生產日期（DC）",
  "sourcePublish.selectManufactureDate": "請選擇生產日期",
  "sourcePublish.unitPrice": "單價",
  "sourcePublish.enterPrice": "請輸入單價",
  "sourcePublish.quantity": "數量",
  "sourcePublish.enterQuantity": "請輸入數量",
  "sourcePublish.unit": "單位",
  "sourcePublish.enterUnit": "請輸入單位",
  "sourcePublish.stockLocation": "貨所在地",
  "sourcePublish.enterStockLocation": "請填寫貨所在地",
  "sourcePublish.batch": "批次(DC)",
  "sourcePublish.enterBatch": "請填寫批次",
  "sourcePublish.condition": "貨物情況",
  "sourcePublish.category": "產品分類",
  "sourcePublish.selectCategory": "請選擇產品分類",
  "sourcePublish.noAttributes": "暫無分類屬性，請選擇二級分類",
  "sourcePublish.moreInfo": "補充資料",
  "sourcePublish.datasheet": "規格書",
  "sourcePublish.uploadDatasheet": "上傳規格書",
  "sourcePublish.originProof": "原產地證明",
  "sourcePublish.uploadProof": "上傳證明",
  "sourcePublish.manufacturer": "廠家",
  "sourcePublish.enterManufacturer": "請填寫廠家",
  "sourcePublish.weight": "重量",
  "sourcePublish.enterWeight": "請填寫重量",
  "sourcePublish.gram": "克",
  "sourcePublish.dimensions": "尺寸",
  "sourcePublish.length": "長",
  "sourcePublish.width": "寬",
  "sourcePublish.height": "高",
  "sourcePublish.enterLength": "請填寫長度",
  "sourcePublish.enterWidth": "請填寫寬度",
  "sourcePublish.enterHeight": "請填寫高度",
  "sourcePublish.millimeter": "毫米",
  "sourcePublish.substitutes": "替代",
  "sourcePublish.applications": "應用",
  "sourcePublish.tagHint": "（用空格或者逗號分開，按回車確認）",
  "sourcePublish.minimumOrder": "起訂量",
  "sourcePublish.enterMinimumOrder": "請填寫起訂量",
  "sourcePublish.validity": "有效期",
  "sourcePublish.selectValidity": "請選擇有效期",
  "sourcePublish.deliveryDays": "交貨天數",
  "sourcePublish.enterDeliveryDays": "請填寫預計交貨天數",
  "sourcePublish.workingDays": "工作日",
  "sourcePublish.ownerCompany": "貨主公司",
  "sourcePublish.enterOwnerCompany": "請填寫貨主公司名稱",
  "sourcePublish.productRemarks": "請填寫產品資料備註",
  "sourcePublish.informationProvider": "資料提供人",
  "sourcePublish.anonymous": "匿名",
  "sourcePublish.assignedNegotiator": "指定談判人",
  "sourcePublish.enterAssignedMobile": "請填寫指定談判人流動電話號碼",
  "sourcePublish.saveDraft": "暫存",
  "sourcePublish.notAvailable": "暫未開放",
  "sourcePublish.buyerInfo": "買家資料",
  "sourcePublish.iAmBuyer": "我是買家",
  "sourcePublish.deliveryAddress": "交貨地址",
  "sourcePublish.enterDeliveryAddress": "請填寫交貨地址",
  "sourcePublish.buyerRemarks": "請填寫買家資料備註",
  "sourcePublish.demandInfo": "需求資料",
  "sourcePublish.targetPrice": "期望價格",
  "sourcePublish.enterTargetPrice": "請填寫期望價格",
  "sourcePublish.enterPurchaseQuantity": "請填寫購買數量",
  "sourcePublish.recommendedNegotiator": "推薦談判人",
  "sourcePublish.enterRecommendedMobile": "請填寫推薦談判人流動電話號碼",
  "sourcePublish.searchCategory": "請輸入分類名稱搜索",
  "sourcePublish.select": "請選擇",
  "sourcePublish.enter": "請輸入",
  "sourcePublish.confirm": "確定",
  "sourcePublish.chipSpecs": "晶片規格",
  "sourcePublish.package": "封裝",
  "sourcePublish.batchShort": "批次",
  "sourcePublish.submit": "提交",
  "sourcePublish.selectDate": "選擇年月日",
  "sourcePublish.bulkUpload": "批量上傳供需資料",
  "sourcePublish.cancel": "取消",
  "sourcePublish.confirmPost": "確認發佈",
  "sourcePublish.postSupply": "發佈貨源",
  "sourcePublish.postSupplyLead": "發佈貨源線索",
  "sourcePublish.postSupplyHint": "填寫貨源資料，發佈貨源線索",
  "sourcePublish.postDemand": "發佈需求",
  "sourcePublish.postDemandLead": "發佈需求線索",
  "sourcePublish.postDemandHint": "填寫需求資料，發佈需求線索",
  "sourcePublish.submitPurchaseIntent": "提交購買意向單",
  "sourcePublish.datasheetAttachment": "規格書附件",
  "sourcePublish.cny": "人民幣",
  "sourcePublish.usd": "美元",
  "sourcePublish.loginFirst": "請先登入",
  "sourcePublish.requiredField": "必填項",
  "sourcePublish.validNumber": "請填寫有效的數字",
  "sourcePublish.postSuccess": "發佈成功",
  "sourcePublish.failed": "失敗",
  "sourcePublish.completeForm": "請填寫完整資料！",
  "sourcePublish.draftSaved": "內容暫存成功！",
  "sourcePublish.uploading": "上傳中...",
  "sourcePublish.uploadSuccess": "上傳成功",
  "sourcePublish.uploadFailed": "上傳失敗",
  "sourcePublish.chooseUpload": "請選擇要上傳的檔案",
  "sourcePublish.waitUpload": "檔案上傳中，請等待上傳完成",
  "sourcePublish.importSuccess": "導入成功",
  "sourcePublish.importFailed": "導入失敗",
  "sourcePublish.approximately": "約",
  "sourcePublish.maxTags": "最多隻能添加{count}個標籤",
  "sourcePublish.purchaseIntentSuccess": "提交訂購意向成功！請等待談判人接單！",
  "sourcePublish.enterAlternativeBrand": "請填寫替代品牌",
  "sourcePublish.model": "料號",
  "sourcePublish.enterAlternativeModel": "請填寫替代料號",
  "sourcePublish.originProofFile": "原產地證明{count}",
});

// 供需详情
export const detail = Object.freeze({
  "supplyDetail.supplyDetails": "供應詳情",
  "supplyDetail.demandDetails": "需求詳情",
  "supplyDetail.stockSupply": "現貨供應",
  "supplyDetail.wanted": "求購需求",
  "supplyDetail.inventoryQuantity": "庫存數量",
  "supplyDetail.demandQuantity": "需求數量",
  "supplyDetail.minimumOrder": "最低訂購量",
  "supplyDetail.warehouseSource": "倉庫／貨源地",
  "supplyDetail.deliveryPeriod": "交付時間",
  "supplyDetail.validity": "有效期",
  "supplyDetail.publisher": "發佈公司",
  "supplyDetail.inquire": "立即詢價",
  "supplyDetail.quote": "我要報價",
  "supplyDetail.companyInfo": "企業資料",
  "supplyDetail.contactName": "聯絡人",
  "supplyDetail.contactPhone": "聯絡電話",
  "supplyDetail.contactNotice": "聯絡資料以平台認證資料及後端回傳內容為準",
  "supplyDetail.details": "詳細資料",
  "supplyDetail.partNumber": "料號",
  "supplyDetail.specifications": "規格參數",
  "supplyDetail.condition": "貨況",
  "supplyDetail.application": "應用場景",
  "supplyDetail.replacements": "替代料號",
  "supplyDetail.productionDate": "生產日期",
  "supplyDetail.tradeNotes": "交易說明",
  "supplyDetail.emptyNotes": "暫無補充說明",
  "supplyDetail.publication": "發佈資料",
  "supplyDetail.publishedAt": "發佈時間",
  "supplyDetail.status": "狀態",
  "supplyDetail.infoType": "供需類型",
  "supplyDetail.notFound": "找不到此供需資料，可能已下架",
  "supplyDetail.backHall": "返回供需大廳",
  "supplyDetail.backList": "返回列表",
  "supplyDetail.longTerm": "長期有效",
  "supplyDetail.validRange": "{from} 至 {to}",
  "supplyDetail.loadFailed": "無法載入供需詳情，請重試",
  "supplyDetail.inquiryPending": "詢價功能開發中…",
  "supplyDetail.quotePending": "報價功能開發中…",
  "supplyDetail.status.pending": "待審核",
  "supplyDetail.status.approved": "已審核",
  "supplyDetail.status.published": "已發佈",
  "supplyDetail.status.offline": "已下架",
});

// 供需大厅
export const hall = Object.freeze({
  "supplyHall.title": "供需大廳",
  "supplyHall.intro": "集中查看供應和需求資料，支持快速篩選、收藏和詳情跟進。",
  "supplyHall.services": "供需服務",
  "supplyHall.serviceHint": "發佈供求資料或完善企業資料",
  "supplyHall.postSupply": "發佈供應",
  "supplyHall.postDemand": "發佈需求",
  "supplyHall.join": "企業入駐",
  "supplyHall.productType": "產品類型：",
  "supplyHall.originalDescription": "原文（簡體中文）",
  "supplyHall.productBrand": "產品品牌：",
  "supplyHall.any": "不限",
  "supplyHall.expand": "展開",
  "supplyHall.collapse": "收起",
  "supplyHall.search": "搜索",
  "supplyHall.all": "全部",
  "supplyHall.supply": "供應",
  "supplyHall.demand": "需求",
  "supplyHall.wanted": "求購",
  "supplyHall.brandPartPlaceholder": "品牌、料號",
  "supplyHall.quantity": "數量",
  "supplyHall.cards": "卡片",
  "supplyHall.table": "表格",
  "supplyHall.uncategorized": "未分類",
  "supplyHall.stock": "庫存",
  "supplyHall.demandQuantity": "需求量",
  "supplyHall.minimumOrder": "起訂",
  "supplyHall.delivery": "交付",
  "supplyHall.viewDetails": "查看詳情",
  "supplyHall.details": "詳情",
  "supplyHall.type": "類型",
  "supplyHall.partNumber": "料號",
  "supplyHall.brand": "品牌",
  "supplyHall.category": "分類",
  "supplyHall.price": "價格",
  "supplyHall.location": "所在地",
  "supplyHall.action": "操作",
  "supplyHall.mainland": "大陸",
  "supplyHall.hongKong": "香港",
  "supplyHall.empty": "暫無相關供需資料",
  "supplyHall.total": "共 {count} 條",
  "supplyHall.searchBrand": "搜索品牌",
  "supplyHall.brandPlaceholder": "請輸入品牌名稱",
  "supplyHall.searching": "搜索中...",
  "supplyHall.noBrand": "未找到匹配的品牌",
  "supplyHall.cancel": "取消",
  "supplyHall.confirm": "確定",
  "supplyHall.loadFailed": "載入供需大廳失敗，請重試",
  "supplyHall.days": "{count}天",
  "supplyHall.chooseBrand": "請選擇品牌",
  "supplyHall.realnameNotice":
    "《網絡安全法》規定，實名才可發佈資料，前往實名認證！",
  "supplyHall.notice": "温馨提示",
  "supplyHall.goRealname": "前往實名認證",
  "supplyHall.joinSuccess": "企業入駐成功",
  "supplyHall.joinFailed": "企業入駐失敗",
  "supplyHall.unfavorited": "已取消收藏",
  "supplyHall.published": "已發佈",
  "supplyHall.favorited": "收藏成功",
  "supplyHall.tenThousands": "{count}萬",
});

// 供需发布
export const publish = Object.freeze({
  "pcPublish.supplyTitle": "供應發佈",
  "pcPublish.demandTitle": "需求發佈",
  "pcPublish.category": "分類",
  "pcPublish.brand": "品牌",
  "pcPublish.partNumber": "料號",
  "pcPublish.unitPrice": "單價",
  "pcPublish.quantity": "數量",
  "pcPublish.batch": "批次",
  "pcPublish.parameters": "參數",
  "pcPublish.tradeNotes": "交易説明(備註)",
  "pcPublish.selectFromList": "請從列表中選擇",
  "pcPublish.searchAndSelect": "輸入關鍵詞搜索並選擇",
  "pcPublish.enterPartNumber": "請輸入料號",
  "pcPublish.enterValue": "請輸入",
  "pcPublish.enterText": "請輸入文字",
  "pcPublish.yuan": "元",
  "pcPublish.confirm": "確認發佈",
  "pcPublish.searchCategory": "搜索分類",
  "pcPublish.searchBrand": "搜索品牌",
  "pcPublish.categoryResult": "共搜索到 {count} 條與“{keyword}”相關的資料",
  "pcPublish.brandCount": "共 {count} 條品牌",
  "pcPublish.noSubcategory": "該分類暫無二級分類，可直接選擇父級",
  "pcPublish.chooseCategory": "選擇該分類",
  "pcPublish.chooseBrand": "選擇品牌",
  "pcPublish.categoryRequired": "請選擇分類！",
  "pcPublish.brandRequired": "請選擇品牌！",
  "pcPublish.partNumberRequired": "請輸入料號！",
  "pcPublish.priceRequired": "請輸入單價！",
  "pcPublish.quantityRequired": "請輸入數量！",
  "pcPublish.success": "發佈成功！",
  "pcPublish.failed": "發佈失敗，請重試！",
  "pcPublish.networkFailed": "發佈失敗，請檢查網絡連接後重試！",
  "pcPublish.images": "圖片",
  "pcPublish.uploadImage": "上傳圖片",
  "pcPublish.categoryHint": "請選擇全站分類",
  "pcPublish.brandHint": "搜索並選擇品牌",
  "pcPublish.partNumberHint": "輸入料號，可搜索選擇",
  "pcPublish.specification": "規格",
  "pcPublish.specificationHint": "請輸入規格",
  "pcPublish.title": "標題名稱",
  "pcPublish.supplyTitleHint": "可按貨源所在地、供應、料號、數量和替代資料填寫",
  "pcPublish.demandTitleHint": "可按貨源所在地、需求、料號、數量和替代資料填寫",
  "pcPublish.currency": "幣種",
  "pcPublish.chooseCurrency": "請選擇幣種",
  "pcPublish.currencyCNY": "CNY - 人民幣",
  "pcPublish.currencyUSD": "USD - 美元",
  "pcPublish.currencyEUR": "EUR - 歐元",
  "pcPublish.currencyGBP": "GBP - 英鎊",
  "pcPublish.currencyJPY": "JPY - 日元",
  "pcPublish.currencyHKD": "HKD - 港幣",
  "pcPublish.unit": "單位",
  "pcPublish.minimumOrder": "起訂量",
  "pcPublish.manufactureDate": "生產日期",
  "pcPublish.chooseDate": "請選擇生產日期",
  "pcPublish.origin": "貨源所在地",
  "pcPublish.enterOrigin": "請輸入貨源所在地",
  "pcPublish.validity": "有效期",
  "pcPublish.chooseValidity": "請選擇有效期",
  "pcPublish.longTerm": "長期有效",
  "pcPublish.deliveryDays": "交貨天數",
  "pcPublish.applications": "應用",
  "pcPublish.tagsHint": "輸入標籤，使用空格或逗號分隔",
  "pcPublish.alternatives": "替代",
  "pcPublish.chooseBrandHint": "請選擇品牌",
  "pcPublish.size": "尺寸",
  "pcPublish.length": "長",
  "pcPublish.width": "寬",
  "pcPublish.height": "高",
  "pcPublish.millimeter": "毫米",
  "pcPublish.weight": "重量",
  "pcPublish.gram": "克",
  "pcPublish.ownerCompany": "貨主公司名稱",
  "pcPublish.defaultCompany": "預設會員公司名稱",
  "pcPublish.datasheet": "上傳規格書",
  "pcPublish.notes": "備註",
  "pcPublish.notesHint": "請輸入備註説明",
  "pcPublish.preview": "發佈預覽",
  "pcPublish.selectAlternativeBrand": "選擇替代品牌",
  "pcPublish.previewUnavailable": "預覽功能開發中...",
  "pcPublish.imageRequired": "請上傳圖片！",
});

// 手机端业务流程：三语只改变固定界面文案。
export const mobileWorkflow = Object.freeze({
  "supplyForm.awaitingContact": "待接待",
  "supplyForm.negotiatorAccepted": "談判人已接單",
  "supplyForm.businessAccepted": "商務已接單",
  "supplyForm.contractCreated": "已產生合同",
  "supplyForm.confirmAmount": "確認金額",
  "supplyForm.buyerPaid": "買家已付款",
  "supplyForm.sellerPaid": "貨主已付款",
  "supplyForm.reviewTitle": "資訊審核",
  "supplyForm.editSupplyLead": "修改貨源線索",
  "supplyForm.enterPrice": "請輸入價格",
  "supplyForm.completeSupply": "談判人完善貨源資訊",
  "supplyForm.uploadImage": "請上傳商品圖片",
  "supplyForm.completeBeforeSave": "請填寫完整資訊後再儲存資料！",
  "supplyForm.bulk": "大宗",
  "supplyForm.searchableTitle": "標題有助於搜尋",
  "supplyForm.enterField": "請填寫",
  "supplyForm.enterCondition": "請填寫貨物情況",
  "supplyForm.enterPackageType": "請填寫封裝類型",
  "supplyForm.enterChipType": "請填寫晶片類型",
  "supplyForm.enterUnitPrice": "請填寫單價",
  "supplyForm.enterProductTitle": "請填寫產品標題",
  "supplyForm.notRegistered": "（未入駐）",
  "supplyForm.saveNext": "儲存並繼續",
  "supplyForm.savePublish": "儲存並發佈貨源",
  "supplyForm.currentStatusPrefix": "目前狀態：",
  "supplyForm.negotiatorPrefix": "談判人：",
  "supplyForm.pdfRequired": "請上傳PDF檔案",
  "supplyForm.pricePositive": "價格必須大於0",
  "supplyForm.quantityPositive": "數量必須大於0",
  "supplyForm.reviewConfirm": "是否審核此資料？",
  "supplyForm.deleteConfirm": "確定要刪除此線索嗎？",
  "supplyForm.dimensionsMm": "{dimensions} 毫米",
  "supplyForm.deliveryWorkdays": "{days} 個工作天",
  "supplyForm.approximateConversion": "（約 {amount} {unit}）",
  "supplyForm.editInformation": "編輯資訊",
  "supplyForm.enterSupplier": "請填寫供應商",
  "supplyForm.enterProductType": "請填寫產品類型",
  "supplyForm.enterArchitecture": "請填寫架構",
  "supplyForm.enterSpeed": "請填寫速率",
  "supplyForm.enterBall": "請填寫球位",
});

// 页面受控选项与属性显示；原始业务值保持不变。
export const publishDisplayFollowup = Object.freeze({
  "publishDisplay.bulk": "大宗",
  "publishDisplay.postSupply": "發佈貨源",
  "publishDisplay.postDemand": "發佈需求",
  "publishDisplay.hasOriginProof": "有原產地證明",
  "publishDisplay.noOriginProof": "無原產地證明",
  "publishDisplay.unknownOriginProof": "不瞭解",
  "publishDisplay.tagExample":
    "例：品類一,品類二,品類三 或 品類一 品類二 品類三",
  "publishDisplay.computers": "電腦",
  "publishDisplay.phones": "手機",
  "publishDisplay.automotive": "汽車",
  "publishDisplay.iot": "物聯網",
  "publishDisplay.networks": "網絡",
});

export const messages = Object.freeze({
  ...publishDisplayFollowup,
  ...mobileWorkflow,
  ...mobileClue,
  ...batchPublish,
  ...desktopClue,
  ...sourcePublish,
  ...detail,
  ...hall,
  ...publish,
});
